import { render, staticRenderFns } from "./TextColorNonEditable.vue?vue&type=template&id=461d7573&scoped=true&lang=html&"
import script from "./TextColorNonEditable.vue?vue&type=script&lang=js&"
export * from "./TextColorNonEditable.vue?vue&type=script&lang=js&"
import style0 from "./TextColorNonEditable.vue?vue&type=style&index=0&id=461d7573&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461d7573",
  null
  
)

export default component.exports